import { Checkbox, DialogContentText, FormControlLabel, Stack } from "@mui/material";
import { useAddChildOrderMutation, useDeleteChildOrderMutation } from "app/api/orders";
import { getErrorMessage } from "utilities/getErrorMessage";
import SimpleDialog, { SimpleDialogProps } from "components/SimpleDialog";
import { Order } from "models/Order";
import { toast } from "react-toastify";

type LinkOrdersDialogProps = { order: Order; onClose: SimpleDialogProps["onClose"] };

const LinkOrdersDialog: React.FC<LinkOrdersDialogProps> = ({ order, onClose }) => {
  const [addChildOrder, { isLoading: isAdding }] = useAddChildOrderMutation();
  const [deleteChildOrder, { isLoading: isDeleting }] = useDeleteChildOrderMutation();

  const onToggleChildOrder = async (childOrderNumber: string, isLinked: boolean) => {
    if (isLinked) {
      await deleteChildOrder({
        parentOrderId: order.ordernr,
        childOrderId: childOrderNumber,
      })
        .unwrap()
        .catch((error) => toast.error(getErrorMessage(error)));
    } else {
      await addChildOrder({
        parentOrderId: order.ordernr,
        childOrderId: childOrderNumber,
      })
        .unwrap()
        .catch((error) => toast.error(getErrorMessage(error)));
    }
  };

  return (
    <SimpleDialog
      title="Länka ordrar"
      onClose={onClose}
      confirmProps={{ hidden: true }}
      dismissProps={{ children: "Stäng" }}
    >
      <Stack>
        {!order.projectOrders?.length ? (
          <DialogContentText>Inga fler ordrar i projektgruppen</DialogContentText>
        ) : (
          <DialogContentText>Välj ordrar som ska rapporteras tillsammans</DialogContentText>
        )}

        {order.projectOrders?.map((childOrderNumber) => {
          const isLinked = order.pairedOrderNumbers?.includes(childOrderNumber) ?? false;

          return (
            <FormControlLabel
              key={childOrderNumber}
              label={childOrderNumber}
              control={
                <Checkbox
                  checked={isLinked}
                  disabled={isDeleting || isAdding}
                  onChange={() => onToggleChildOrder(childOrderNumber, isLinked)}
                />
              }
            />
          );
        })}
      </Stack>
    </SimpleDialog>
  );
};

export default LinkOrdersDialog;
